import { Box, Modal, Grid, Zoom, Checkbox, FormControlLabel, RadioGroup, Stack } from '@mui/material';
import { BackdropLoading } from '../../../shared/spinner/backdropLoading';
import { CancelButton, CheckBoxContainer, ModalLabel, modalStyle, OkButton, OperatorRadio } from './shozaichiCondition.styles';
import React, { useRef } from 'react';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SearchCrudApiRequest } from '../../../shared/model/apiRequestModel';
import { SystemErrorMsg, SystemErrorTitle } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import crud from '../../../shared/api/crud';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (value: DialogItemType[], operator: string) => void,
}

interface DialogItemType {
    id: string[]
    value: string
}

interface TodofukenInfo {
    todofukenCode: string[]
    todofukenName: string
}

interface ShikugunInfo {
    todofukenCode: string[]
    todofukenName: string
    shikugunCode: string
    shikugunName: string
}

interface TodofukenItem {
    todofukenCode: string[]
    todofukenName: string
    checked: boolean
    searchHiddenFlag: boolean
}

interface ShikugunItem {
    todofukenCode: string[]
    shikugunCode: string
    shikugunName: string
    checked: boolean
    searchHiddenFlag: boolean
    checkHiddenFlag: boolean
}

const screenId = "U045"

const ShozaichiDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [operator, setOperator] = React.useState('or');
    const [todofukenInfoList, setTodofukenInfoList] = React.useState<TodofukenInfo[]>([]);
    const [shikugunInfoList, setShikugunInfoList] = React.useState<ShikugunInfo[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [todofukenItems, setTodofukenItems] = React.useState<TodofukenItem[]>([])
    const [shikugunItems, setShikugunItems] = React.useState<ShikugunItem[]>([])
    const [error, setError] = React.useState(false)
    const idRef = useRef(0);

    const getTodohuken = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getTodohuken", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;

        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_JUSHO',
            selectItems: ['JSHCDTDFKEN', 'JSHTDFKENMEKNJ'],
            conditions: [
                {
                    targetColumn: "JSHCDSIKGN",
                    targetValue: ['00']
                },
                {
                    targetColumn: "JSHCDCHSNAZCHM",
                    targetValue: ['00000']
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'JSHCDTDFKEN',
                    sortRule: 'ASC',
                },
                {
                    sortColumn: 'JSHCDSIKGN',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }
        const response = crud(request)
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const todofukenList: TodofukenInfo[] = [];
            // 複数の都道府県コードを持つ都道府県があるので都道府県名で単位で都道府県コードを管理する
            (await response).data?.resultData.forEach((item: { JSHTDFKENMEKNJ: string; JSHCDTDFKEN: string; }) => {
                if (todofukenList.find((v) => v.todofukenName === item.JSHTDFKENMEKNJ)) {
                    todofukenList.find((v) => v.todofukenName === item.JSHTDFKENMEKNJ)?.todofukenCode.push(item.JSHCDTDFKEN)
                } else {
                    todofukenList.push({ todofukenCode: [item.JSHCDTDFKEN], todofukenName: item.JSHTDFKENMEKNJ, })
                }
            });
            setLoading(false);
            setTodofukenInfoList(todofukenList);
        } else {
            setLoading(false);
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        };
    }

    const getShikugun = async (todofukenCode: string[], currentId: number) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getShikugun", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;

        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_JUSHO',
            selectItems: ['JSHCDTDFKEN', 'JSHCDSIKGN', 'JSHTDFKENMEKNJ', 'JSHSIKGNCHSNAZCHMKNJ'],
            conditions: [
                {
                    targetColumn: "JSHCDTDFKEN",
                    targetValue: todofukenCode
                },
                {
                    targetColumn: "JSHCDCHSNAZCHM",
                    targetValue: ['00000']
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'JSHCDTDFKEN',
                    sortRule: 'ASC',
                },
                {
                    sortColumn: 'JSHCDSIKGN',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }

        const response = crud(request)

        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const shikugunList = (await response).data?.resultData.map((item: { JSHCDTDFKEN: string; JSHCDSIKGN: string; JSHTDFKENMEKNJ: string; JSHSIKGNCHSNAZCHMKNJ: string; }) => {
                return { todofukenCode: item.JSHCDTDFKEN, shikugunCode: item.JSHCDSIKGN, todofukenName: item.JSHTDFKENMEKNJ, shikugunName: item.JSHSIKGNCHSNAZCHMKNJ }
            });

            // 検索結果から都道府県（市区郡コード：00を除外した値を格納する）
            setLoading(false);
            if (currentId !== idRef.current) return;
            setShikugunInfoList(shikugunList.filter((v: ShikugunItem) => v.shikugunCode !== "00"));
        } else {
            setLoading(false);
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    React.useEffect(() => {
        if (isOpen) {
            setError(false);
            setOperator('or');
            if (todofukenInfoList.length === 0 && shikugunInfoList.length === 0) {
                getTodohuken()
                setShikugunInfoList([])
            } else {
                const todofukenItems: TodofukenItem[] = []
                todofukenInfoList.map((v) => todofukenItems.push({ todofukenCode: v.todofukenCode, todofukenName: v.todofukenName, checked: false, searchHiddenFlag: false }))
                setTodofukenItems(todofukenItems)
                setShikugunInfoList([])
            }

        }
        setOpen(isOpen)
    }, [isOpen])

    React.useEffect(() => {
        const todofukenItems: TodofukenItem[] = []
        todofukenInfoList.map((v) => todofukenItems.push({ todofukenCode: v.todofukenCode, todofukenName: v.todofukenName, checked: false, searchHiddenFlag: false }))
        setTodofukenItems(todofukenItems)
    }, [todofukenInfoList])

    React.useEffect(() => {
        const shikugunItems: ShikugunItem[] = []
        shikugunInfoList.map((v) => shikugunItems.push({ todofukenCode: v.todofukenCode, shikugunCode: v.shikugunCode, shikugunName: v.shikugunName, checked: false, searchHiddenFlag: false, checkHiddenFlag: true }))
        setShikugunItems(shikugunItems)
    }, [shikugunInfoList])

    React.useEffect(() => {
        const currentId = ++idRef.current;
        const checkedTodofukenList = todofukenItems.filter((v) => v.checked === true)
        if (checkedTodofukenList.length === 0 || checkedTodofukenList.length >= 2) {
            setShikugunInfoList([])
        } else {
            getShikugun(checkedTodofukenList[0].todofukenCode, currentId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [todofukenItems])

    const handleChangeTodofuken = (isChecked: boolean, i: number) => {
        const newTodofukenItems = [...todofukenItems]
        newTodofukenItems[i].checked = isChecked
        setTodofukenItems(newTodofukenItems);
    };

    const handleChangeShikugun = (isChecked: boolean, i: number) => {
        const newShikugunItems = [...shikugunItems]
        newShikugunItems[i].checked = isChecked
        setShikugunItems(newShikugunItems);
    };

    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "shozaichiHandleOk", navigate)) {
            return
        }
        const checkedTodofukenItems = todofukenItems.filter((v) => v.checked === true).map((v) => { return { id: v.todofukenCode, value: v.todofukenName } })
        const checkedShikugunItems = shikugunItems.filter((v) => v.checked === true).map((v) => { return { id: [v.todofukenCode + v.shikugunCode], value: checkedTodofukenItems[0].value + v.shikugunName } })
        if (checkedTodofukenItems.length === 0 && checkedShikugunItems.length === 0) {
            setError(true);
        } else if (checkedShikugunItems.length === 0) {
            props.handleOk(checkedTodofukenItems, operator)
        } else {
            props.handleOk(checkedShikugunItems, operator)
        }
    }

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 所在地
                        </ModalLabel>
                        <Stack direction={"row"} marginTop={1} >
                            <Box marginLeft={3} alignContent='center'>
                                <RadioGroup row value={operator} onChange={e => setOperator(e.target.value)} >
                                    <FormControlLabel value="and" control={<OperatorRadio />} label="AND" disabled />
                                    <FormControlLabel value="or" control={<OperatorRadio />} label="OR" disabled />
                                </RadioGroup>
                            </Box>
                            {
                                error ?
                                    <Box alignContent='center' marginLeft={3} sx={{ color: 'red', fontSize: '1.2rem' }}>   条件を一つ以上選択してください</Box>
                                    :
                                    <></>
                            }
                        </Stack>
                        <Box p={1} marginBottom={1}>
                            <Grid container justifyContent="center" columnGap={1}>
                                <Grid container size={5.9}>
                                    <CheckBoxContainer>
                                        {todofukenInfoList.map((v, i) => {
                                            return (
                                                <>
                                                    {todofukenItems[i]?.searchHiddenFlag ? todofukenItems[i].searchHiddenFlag : true && <><FormControlLabel
                                                        sx={{ whiteSpace: "pre-wrap" }}
                                                        label={v.todofukenName}
                                                        control={<Checkbox checked={todofukenItems[i]?.checked ? todofukenItems[i].checked : false} onChange={(e) => handleChangeTodofuken(e.target.checked, i)} />} /><br /></>}
                                                </>
                                            )
                                        })}
                                    </CheckBoxContainer>
                                </Grid>
                                <Grid container size={5.9}>
                                    <CheckBoxContainer>
                                        {shikugunInfoList.map((v, i) => {
                                            return (
                                                <>
                                                    {shikugunItems[i]?.searchHiddenFlag ? shikugunItems[i].searchHiddenFlag : true && <><FormControlLabel
                                                        sx={{ whiteSpace: "pre-wrap" }}
                                                        label={v.shikugunName}
                                                        control={<Checkbox checked={shikugunItems[i]?.checked ? shikugunItems[i].checked : false} onChange={(e) => handleChangeShikugun(e.target.checked, i)} />} /><br /></>}
                                                </>
                                            )
                                        })}
                                    </CheckBoxContainer>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box p={2} sx={{ marginTop: '-3%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default ShozaichiDialog;
